import { render } from "./BarButtonGeneric.vue?vue&type=template&id=4f947989"
import script from "./BarButtonGeneric.vue?vue&type=script&lang=js"
export * from "./BarButtonGeneric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__